import { useSettingsStore } from "../stores/settingsStore";
import type { IDataModel } from "../property-config/initialDataModel";

/** The effective datamodel bindings from the directory configuration. */
export function useDataModel(): IDataModel {
  return useSettingsStore().config.dataModel;
}

/**
 * The provider a service belongs to, resolved through the configured
 * providerRefOnService relation (e.g. service_providers, formerly biobank).
 */
export function getServiceProvider(service: any) {
  return service?.[useDataModel().providerRefOnService];
}
